import React, { lazy } from 'react';
import Loadable from 'app/components/Loadable';

const MaintenancePeriods = Loadable(lazy(() => import('./MaintenancePeriods')));

const maintenanceRoutes = [
  {
    path: 'maintenance/periods',
    element: <MaintenancePeriods />,
  }
];

export default maintenanceRoutes;
